import {
  RefundRequestSource,
  RefundRequestStatus,
  RefundRequestTriggerType,
} from "../schemas/refund-request.schema";
import { SPLOOT_BADGE_COLOR } from "../themes";

export const REFUND_REQUEST_STATUS_LABELS: Record<RefundRequestStatus, string> = {
  [RefundRequestStatus.PENDING_APPROVAL]: "Pending Approval",
  [RefundRequestStatus.PROCESSING]: "Processing",
  [RefundRequestStatus.INITIATED]: "Initiated",
  [RefundRequestStatus.COMPLETED]: "Completed",
  [RefundRequestStatus.FAILED]: "Failed",
  [RefundRequestStatus.REJECTED]: "Rejected",
};

export const REFUND_REQUEST_STATUS_COLORS: Record<RefundRequestStatus, SPLOOT_BADGE_COLOR> = {
  [RefundRequestStatus.PENDING_APPROVAL]: SPLOOT_BADGE_COLOR.ORANGE,
  [RefundRequestStatus.PROCESSING]: SPLOOT_BADGE_COLOR.BLUE,
  [RefundRequestStatus.INITIATED]: SPLOOT_BADGE_COLOR.BLUE,
  [RefundRequestStatus.COMPLETED]: SPLOOT_BADGE_COLOR.GREEN,
  [RefundRequestStatus.FAILED]: SPLOOT_BADGE_COLOR.RED,
  [RefundRequestStatus.REJECTED]: SPLOOT_BADGE_COLOR.GRAY,
};

export const REFUND_REQUEST_TRIGGER_LABELS: Record<RefundRequestTriggerType, string> = {
  [RefundRequestTriggerType.FULFILLMENT]: "Fulfillment",
  [RefundRequestTriggerType.EDIT]: "Order Edit",
  [RefundRequestTriggerType.CANCELLATION]: "Order Cancellation",
  [RefundRequestTriggerType.SESSION_CANCELLATION]: "Session Cancellation",
};

export const REFUND_REQUEST_SOURCE_LABELS: Record<RefundRequestSource, string> = {
  [RefundRequestSource.ADMIN]: "Admin",
  [RefundRequestSource.SUPPORT]: "Support",
  [RefundRequestSource.SYSTEM]: "System",
};
